export const WORK_MODE_STORAGE_KEY = "fr_work_mode";
export const WORK_MODE_CHANGE_EVENT = "fr-work-mode-change";

export const WORK_MODE = {
  ONLINE: "online",
  OFFLINE: "offline",
};

export function isOfflineWorkMode() {
  try {
    if (typeof window === "undefined") return false;
    return window.localStorage.getItem(WORK_MODE_STORAGE_KEY) === WORK_MODE.OFFLINE;
  } catch {
    return false;
  }
}
